import MaterialTable from "@material-table/core";
import useFilterState from "../../../hooks/useFilterState";
import _ from "lodash";

const OrdersMaterialTable = (props) => {
  const orderTable = "Load Schedule";
  const { tableName, tableRef, columns, tableData, pageSize, setPageNumber } =
    props;

  const onPageChange = (e) => {
    setPageNumber(e);
  };

  const [columnsWithFilter, handleFilterChange] = useFilterState(
    tableName,
    columns
  );

  return (
    <div id="load-schedule-table">
      <MaterialTable
        tableRef={tableRef}
        enablePagination={false}
        localization={{
          body: {
            emptyDataSourceMessage: (
              <h6 className="left-[45%] absolute top-[40%] text-center">
                No records to display
              </h6>
            ),
          },
          pagination: {
            labelRowsPerPage: "Orders Per Page",
            labelRowsSelect: "Orders",
          },
        }}
        options={{
          rowStyle: {
            fontSize: 8,
            overflowWrap: "break-word",
          },
          paging: true,
          pageSize: 100,
          filtering: true,
          search: false,
          showTitle: false,
          grouping: true,
          maxBodyHeight: 600,
          headerStyle: {
            backgroundColor: "#367c2b",
            fontWeight: "400",
            color: "white",
            fontSize: "10px",
            position: "sticky",
            top: 0,
            zIndex: 10,
          },
          tableContainerStyle: {
            maxHeight: 600,
            overflow: "auto",
          },
          pageSizeOptions: [100, 500, 1000],
          filterCellStyle: {
            flex: 1,
          },
        }}
        title={orderTable}
        columns={columnsWithFilter.map((col, index) => {
          if (
            col.tableData?.filterValue == "" ||
            col.tableData?.filterValue == null ||
            col.tableData?.filterValue == undefined
          ) {
            let colWithoutDefaultFilter = _.omit(
              col,
              "defaultFilter",
              "tableData.filterValue"
            );
            return colWithoutDefaultFilter;
          } else {
            return {
              ...col,
              defaultFilter: col.tableData?.filterValue,
            };
          }
        })}
        data={tableData}
        onFilterChange={(filters) => {
          // Create a map of current filters for quick lookup
          const filterMap = new Map();
          filters.forEach((filter) => {
            filterMap.set(filter.column.tableData.id, filter.value);
          });

          // Iterate over all columns to ensure each one is checked if the value is present in the filter map
          columnsWithFilter.forEach((col, columnId) => {
            const newValue = filterMap.get(columnId) || ""; // Default to empty string if not found

            // Update the filter state for each column
            handleFilterChange(columnId, newValue);
          });
        }}
        onChangePage={(e) => onPageChange(e)}
      />
    </div>
  );
};
export default OrdersMaterialTable;
